import { mutatorAction } from 'satcheljs';
import { getComposeStoreManager } from '../store/store';

export const addComposeStore = mutatorAction('addComposeStore', (formId: string) => {
    getComposeStoreManager().storeMap.set(formId, {
        formId: formId,
        openedForm: null,
        originalEvent: null,
        event: null,
        uiState: null,
        metricsInfo: null,
        attachmentFiles: null,
    });
});

export const removeComposeStore = mutatorAction('removeComposeStore', (formId: string) => {
    getComposeStoreManager().storeMap.delete(formId);
});
